import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isDownloading: false,
  downloadError: undefined,
  downloadedRows: [],
  successMessage: undefined,
};

const drmInactiveCeaSlice = createSlice({
  name: "drmInactiveCea",
  initialState,
  reducers: {
    downloadInactiveCeaStart: (state) => {
      state.isDownloading = true;
      state.downloadError = undefined;
      state.downloadedRows = [];
      state.successMessage = undefined;
    },
    downloadInactiveCeaSuccess: (state, action) => {
      const { rows = [], message } = action.payload || {};
      state.isDownloading = false;
      state.downloadedRows = rows;
      state.successMessage = message;
    },
    downloadInactiveCeaFailure: (state, action) => {
      state.isDownloading = false;
      state.downloadError = action.payload;
      state.downloadedRows = [];
    },
    resetInactiveCeaState: () => ({ ...initialState }),
  },
});

export const {
  downloadInactiveCeaStart,
  downloadInactiveCeaSuccess,
  downloadInactiveCeaFailure,
  resetInactiveCeaState,
} = drmInactiveCeaSlice.actions;

export default drmInactiveCeaSlice.reducer;
